import { api } from '../configs/axiosConfigs';

export const deleteListUpload = async(listUploadId: string) => {
  return await api.delete(`/list-uploads/${listUploadId}.json`);
};
